import { render } from "./ButtonIconRound.vue?vue&type=template&id=3531c690&ts=true"
import script from "./ButtonIconRound.vue?vue&type=script&lang=ts"
export * from "./ButtonIconRound.vue?vue&type=script&lang=ts"

import "./ButtonIconRound.vue?vue&type=style&index=0&id=3531c690&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__